import getDatesOnEndDateChanged from 'owa-datetime-utils/lib/dateSelector/getDatesOnEndDateChanged';
import getDatesOnEndTimeChanged from 'owa-datetime-utils/lib/dateSelector/getDatesOnEndTimeChanged';
import getDatesOnStartDateChanged from 'owa-datetime-utils/lib/dateSelector/getDatesOnStartDateChanged';
import getDatesOnStartTimeChanged from 'owa-datetime-utils/lib/dateSelector/getDatesOnStartTimeChanged';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import { updateDateTimes } from 'owa-calendar-compose-form-actions';
import { TimeChangeActionType } from 'owa-calendar-helpers-types/lib/TimeChangeActionType';
import {
    owaDate,
    getTimestamp,
    isBefore,
    startOfDay,
    addDays,
    mergeDateAndTime,
} from 'owa-datetime';

/** This is part of the add-ins API and must return a PLAIN Date with the UTC timestamp */
export const getStartTime = (): Date => {
    const event = getComposeStore().event;
    const start = owaDate(event.StartTimeZoneId, event.Start);
    const date = event.IsAllDayEvent ? startOfDay(start) : start;
    return new Date(getTimestamp(date));
};

/** This is part of the add-ins API and must accept a PLAIN Date with the UTC timestamp */
export const setStartTime = (startTime: Date): void => {
    const event = getComposeStore().event;
    const eventStart = owaDate(event.StartTimeZoneId, event.Start);
    const eventEnd = owaDate(event.EndTimeZoneId, event.End);
    const newStartDateTime = owaDate(event.StartTimeZoneId, startTime.getTime());
    const selectedDates: OwaDateRange = getDatesOnStartDateChanged(
        eventStart,
        eventEnd,
        newStartDateTime
    );
    const selectedTimes: OwaDateRange = getDatesOnStartTimeChanged(
        eventStart,
        eventEnd,
        newStartDateTime,
        false /* shouldAlwaysKeepDuration */
    );
    const selectedRange: OwaDateRange = {
        start: mergeDateAndTime(selectedDates.start, selectedTimes.start),
        end: mergeDateAndTime(selectedDates.end, selectedTimes.end),
    };
    updateDateTimes(selectedRange, TimeChangeActionType.AddinsStartTime);
};

/** This is part of the add-ins API and must return a PLAIN Date with the UTC timestamp */
export const getEndTime = (): Date => {
    const event = getComposeStore().event;
    const end = owaDate(event.EndTimeZoneId, event.End);
    const date = event.IsAllDayEvent ? startOfDay(addDays(end, 1)) : end;
    return new Date(getTimestamp(date));
};

/** This is part of the add-ins API and must accept a PLAIN Date with the UTC timestamp */
export const setEndTime = (endTime: Date): boolean => {
    const event = getComposeStore().event;
    const eventStart = owaDate(event.StartTimeZoneId, event.Start);
    const eventEnd = owaDate(event.EndTimeZoneId, event.End);
    const newEndDateTime = owaDate(event.EndTimeZoneId, endTime.getTime());

    if (isBefore(newEndDateTime, eventStart)) {
        return false;
    }

    let selectedDates: OwaDateRange = getDatesOnEndDateChanged(
        eventStart,
        eventEnd,
        newEndDateTime
    );
    let selectedTimes: OwaDateRange = getDatesOnEndTimeChanged(
        eventStart,
        eventEnd,
        newEndDateTime
    );
    const selectedRange: OwaDateRange = {
        start: mergeDateAndTime(selectedDates.start, selectedTimes.start),
        end: mergeDateAndTime(selectedDates.end, selectedTimes.end),
    };
    updateDateTimes(selectedRange, TimeChangeActionType.AddinsEndTime);
    return true;
};
